export default "__VITE_ASSET__fac47317__"